export const container = `list-none p-0`;
export const item = `flex items-center`;
export const itemColor = `w-3 h-3 rounded mr-2.5`;
